import classnames from 'classnames'
import React from 'react'

import styles from './product-tags.module.scss'

const ReadyToShip = ({ shouldShowReadyToShipTag }: { shouldShowReadyToShipTag: boolean }) => {
  return shouldShowReadyToShipTag ? (
    <li className={classnames(styles.tag)} key="readyToShip">
      Ready to Ship
    </li>
  ) : null
}

export { ReadyToShip }
